import { LS_DEFAULT_LANGUAGE } from "../constants/storage";
import { DEFAULT_LANGUAGE } from "../constants/defaults";
import i18n from "../i18n";
import { GET_PROD_OR_DEV,GET_API_GAME_URL } from "../constants/api";
import { Auth } from "aws-amplify";
import { APP_KEY, CUSTOM_PERMISSIONS } from "../constants/users_login";
import { isPaid } from "./sessionHelpers";
import * as h from "./analyticsHelpers";
import Cookies from "universal-cookie";
import Crypto from "crypto-js";
import config from "../aws-exports";


export const arrayToSelectObject = (values, funcs) => {
  let finalObject = null;
  if (values) {
    let index = 0;
    finalObject = values.map((value) => {
      return {
        value,
        func: funcs && funcs[index] ? funcs[index++] : () => {},
      };
    });
  }
  return finalObject;
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const isDateInRange = (startDate, endDate) => {
  const currentDate = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  const isWithinRange = currentDate >= start && currentDate <= end;
  return isWithinRange;
};

export const randomWithSeed = (seed, ocurrences = 1, activityMap) => {
  seed = parseInt(seed);
  const selectedIds = [];
  const usedIndexes = new Set();

  while (
    selectedIds.length < ocurrences &&
    usedIndexes.size < activityMap.length
  ) {
    const x = Math.sin(seed++) * 10000;
    const rand = x - Math.floor(x);
    const index = Math.floor(rand * activityMap.length);
    if (!usedIndexes.has(index)) {
      usedIndexes.add(index);
      selectedIds.push(activityMap[index]);
    }
  }
  return selectedIds;
};

export const callBifrost = (link, returnUrl) => {
  return Auth.currentAuthenticatedUser().then((cognitoUser) => {
    let tokenA = cognitoUser.signInUserSession.accessToken.jwtToken,
      tokenI = cognitoUser.signInUserSession.idToken.jwtToken,
      tokenR = cognitoUser.signInUserSession.refreshToken.token;

    const sKey = config.Heimdall;

    const cookies = new Cookies();

    let newTokensA = Crypto.AES.encrypt(tokenA, sKey).toString();
    let newTokensI = Crypto.AES.encrypt(tokenI, sKey).toString();
    //let newTokensR = Crypto.AES.encrypt(tokenR, sKey).toString();

    let newToken = Crypto.AES.encrypt(tokenA, sKey);
    let newKey = Crypto.SHA256(cognitoUser.username, sKey);
    newKey = newKey.toString();

    cookies.set(newKey + "A", newTokensA, {
      path: "/",
      domain: ".afinandoocerebro.com.br",
      maxAge: 10,
    });
    cookies.set(newKey + "I", newTokensI, {
      path: "/",
      domain: ".afinandoocerebro.com.br",
      maxAge: 10,
    });
    cookies.set(newKey + "R", tokenR, {
      path: "/",
      domain: ".afinandoocerebro.com.br",
      maxAge: 10,
    });
    let VerifyReturn =
      returnUrl !== undefined
        ? link + "?u=" + encodeURIComponent(newToken) + "&st=" + returnUrl
        : // : window.location.href = link + "?u=" + encodeURIComponent(newToken);

          window.open(link + "?u=" + encodeURIComponent(newToken));

    return VerifyReturn;
  });
};

// [important] HAVE TO BE "!="  because its compare null AND undefined
// [important] "!==" its compare ONLY IF null
export const checkExist = (item) => {
  return item != null;
};

export const checkValidLink = (item) => {
  return item != null && (item === true || item === false);
};

// Set default language
export const setLanguage = (lang) => {
  if (!lang) {
    lang = localStorage.getItem(LS_DEFAULT_LANGUAGE)
      ? localStorage.getItem(LS_DEFAULT_LANGUAGE)
      : DEFAULT_LANGUAGE;
  }
  localStorage.setItem(LS_DEFAULT_LANGUAGE, lang);
  i18n.changeLanguage(lang);
};

// Set default language
export const getLanguage = () => {
  let lang = LS_DEFAULT_LANGUAGE;
  if (localStorage.getItem(LS_DEFAULT_LANGUAGE))
    lang = localStorage.getItem(LS_DEFAULT_LANGUAGE);
  else localStorage.setItem(LS_DEFAULT_LANGUAGE, lang);
  return lang;
};

export const isActiveLanguage = (lang) => {
  return getLanguage() === lang;
};

export const getKeyGen = (key = "") => {
  return key + Math.random() + new Date().getMilliseconds();
};

export const getSplitedDate = (date) => {
  date = date.replace(" ", "T");
  const FormattedDate = new Date(date);
  let day = FormattedDate.getDate();
  day = day < 10 ? "0" + day : day;
  // getMonth() return (0 - 11)
  let month = FormattedDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  return [day, month, FormattedDate.getFullYear()];
};

export const sortByAttributeID = (list, att = "name", notReverse = true) => {
  if (list && att) {
    list = list.sort((patA, patB) => {
      return parseInt(patA[att]) < parseInt(patB[att]) ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const sortByAttribute = (list, att = "name", notReverse = true) => {
  if (list && att) {
    list = list.sort((patA, patB) => {
      return patA[att] < patB[att] ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const sortByInnerAttribute = (
  list,
  firstAtt = "",
  secondtAtt = "",
  notReverse = true
) => {
  if (list && firstAtt && secondtAtt) {
    list = list.sort((patA, patB) => {
      return patA[firstAtt][secondtAtt] < patB[firstAtt][secondtAtt] ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const simplestText = (text = null) => {
  if (text) {
    text = text.toString().toLowerCase().replace("-", "_");
    text = text.replace(new RegExp("[ÁÀÂÃÄ]", "gi"), "a");
    text = text.replace(new RegExp("[ÉÈÊË]", "gi"), "e");
    text = text.replace(new RegExp("[ÍÌÎÏ]", "gi"), "i");
    text = text.replace(new RegExp("[ÓÒÔÕÖ)]", "gi"), "o");
    text = text.replace(new RegExp("[ÚÙÛÜ]", "gi"), "u");
    text = text.replace(new RegExp("[Ç]", "gi"), "c");
  }
  return text;
};

export const openExternalLink = (link) => {
  const win = window.open(link, "_blank");
  win.focus();
};

export const openActivityAsPopUp = (
  activityUrl,
  activeUser = null,
  isParentPaid = null,
  game_name = null,
  game_id = null,
  typeUser = null,
  profile = null
) => {
  if (activityUrl) {
    /* if (game_name && game_id)
      h.setAnalyticsPlayGame({
        name: game_name,
        id: game_id,
      });
 */
    let playerSub = "";
    const user = Auth.user.attributes
      ? Auth.user.attributes
      : Auth.user.signInUserSession.idToken.payload;

    if (activeUser && activeUser.sub) playerSub = activeUser.sub;
    else playerSub = user.sub;
    const queryParentUserIsPaid = "&parent_user_is_paid=" + isParentPaid;
    let queryUserIsPaid = "&user_is_paid=" + isPaid();
    let queryPermission = "";
    let tempPermission = "";
    let idLogin = "&id_login=" + user.sub;
    try {
      tempPermission = JSON.parse(user[CUSTOM_PERMISSIONS]);
      if (tempPermission && tempPermission[APP_KEY])
        queryPermission = "&permitions=" + tempPermission[APP_KEY];
    } catch (error) {}

    const url =
      (typeof yourVariable === "object"
        ? activityUrl[GET_PROD_OR_DEV]
        : activityUrl) +
      `&id_usu=${playerSub}` +
      "&plataforma=web" +
      queryParentUserIsPaid +
      queryUserIsPaid +
      queryPermission +
      idLogin;
    // "&name="+game_name;
    return url;
  }
};

export const getActivityUrl = (
  activity,
  activeUser = null,
  isParentPaid = null,
) => {

  const activityUrl = GET_API_GAME_URL(activity);
  if (!activityUrl) return;

 /*  h.setAnalyticsPlayGame({
    name: activity.name,
    id: activity.id,
  }); */
  //tratar com redirect
  const user = Auth.user?.attributes || Auth.user?.signInUserSession.idToken.payload;
  const playerSub = activeUser?.sub || user.sub;
  const queryParentUserIsPaid = isParentPaid ? `&parent_user_is_paid=${isParentPaid}` : "";
  const queryUserIsPaid = `&user_is_paid=${isPaid()}`;
  const idLogin = `&id_login=${user.sub}`;
  let queryPermission = "";
  try {
    const tempPermission = JSON.parse(user[CUSTOM_PERMISSIONS]);
    if (tempPermission?.[APP_KEY]) {
      queryPermission = `&permitions=${tempPermission[APP_KEY]}`;
    }
  } catch (error) {
    console.error("Erro ao buscar permissões do usuário", error);
    window.location.href = "/painel"; 
  }
  const baseUrl = typeof activityUrl === "object" ? activityUrl[GET_PROD_OR_DEV] : activityUrl;
  const url = `${baseUrl}&id_usu=${playerSub}&plataforma=web${queryParentUserIsPaid}${queryUserIsPaid}${queryPermission}${idLogin}`;

  return url;
};


export const checkIsNewHelper = (date, name) => {
  date = new Date(date).getTime();
  const today = new Date().getTime();
  const diffDays = parseInt((today - date) / (1000 * 60 * 60 * 24), 10);
  return diffDays < 31;
};

export const checkIsEqualText = (textA, textB) => {
  return simplestText(textA) === simplestText(textB);
};

export const checkIsEqualNumber = (numberA, numberB) => {
  return parseInt(numberA) === parseInt(numberB);
};

export const checkListSize = (list, att) => {
  if (att) return list && list[att] && list[att].length > 0;
  else return list && list.length > 0;
};

// Convert H:M:S to seconds
// Seconds are optional (i.e. n:n is treated as h:s)
const hmsToSeconds = (s) => {
  var b = s.split(":");
  return b[0] * 60 + (+b[1] || 0);
};

// Convert seconds to hh:mm:ss
// Allow for -ve time values
const secondsToHMS = (secs) => {
  function z(n) {
    return (n < 10 ? "0" : "") + n;
  }
  var sign = secs < 0 ? "-" : "+";
  secs = Math.abs(secs);
  return sign + z(((secs % 3600) / 60) | 0) + ":" + z(secs % 60);
};

export const twoDigits = (day = "") =>
  day.toString().length < 2 ? "0" + day : day;

export const diffInMinutes = (firstTime = "00:00", secondTime = "00:00") => {
  secondTime = hmsToSeconds(secondTime);
  firstTime = hmsToSeconds(firstTime);
  return secondsToHMS(secondTime - firstTime);
};

export const shortText = (text = "") => {
  let tempBody = text;
  if (text.length > 150) {
    tempBody = text.substr(0, 150);
    if (
      tempBody[tempBody.length - 1] === " " ||
      tempBody[tempBody.length - 1] === "."
    )
      tempBody = text.substr(0, 149);
    tempBody = tempBody + "...";
  }
  return tempBody;
};

export const getColorByLetters = (name = "-") => {
  // let letterA = "";
  // let notFound = [133, 172, 172];
  // let finalColor = "rgba(133, 172, 172)";

  // if (name[0]) letterA = simplestText(name[0]);

  // const dictionary = {
  //   a: [165, 165, 115],
  //   b: [185, 185, 228],
  //   c: [235, 170, 170],
  //   d: [184, 224, 184],
  //   e: [219, 100, 100],
  //   f: [136, 192, 192],
  //   g: [236, 236, 161],
  //   h: [67, 201, 201],
  //   i: [192, 192, 192],
  //   j: [231, 165, 231],
  //   k: [84, 84, 209],
  //   l: [123, 224, 123],
  //   m: [128, 128, 128],
  //   n: [223, 185, 115],
  //   o: [219, 110, 110],
  //   p: [127, 255, 212],
  //   q: [243, 149, 115],
  //   r: [189, 88, 189],
  //   s: [245, 222, 179],
  //   t: [70, 168, 70],
  //   u: [182, 84, 104],
  //   v: [240, 230, 140],
  //   w: [255, 192, 203],
  //   x: [209, 105, 209],
  //   y: [221, 160, 221],
  //   z: [196, 196, 78],
  // };

  // let colorA = dictionary[letterA];
  // if (!colorA) colorA = notFound;

  // const colorMixC = colorA[0];
  // const colorMixM = colorA[1];
  // const colorMixY = colorA[2];
  // finalColor = "rgb(" + colorMixC + ", " + colorMixM + ", " + colorMixY + ")";
  // finalColor = "#fdfdfd";

  // return finalColor;
  return "#fdfdfd";
};

export const nextEncode = (data) => {
  let dataToRetun =
    Buffer.from(data, "utf8").toString("base64") +
    Buffer.from("afinando_next", "utf8").toString("base64");
  return Buffer.from(dataToRetun, "utf8").toString("base64");
};

export const nextDecode = (data) => {
  let afinando_next = Buffer.from("afinando_next", "utf8").toString("base64");
  data = Buffer(data, "base64").toString();
  data = data.replace(afinando_next, "");
  return Buffer(data, "base64").toString();
};

/**
 *
 * @param {0 - 100} score
 * @description return a objecjet {color: hexa, colorBorder: hexa}, red / yellow / green
 */
export const getColorsScores = (score) => {
  score = parseInt(score);
  let color = "#e6ffdc";
  let colorBorder = "#24660a";
  if (score < 50) {
    color = "#ffcdcd";
    colorBorder = "#d6373a";
  } else if (score >= 50 && score < 80) {
    color = "#ffffcb";
    colorBorder = "#c5a82f";
  }
  return {
    color: color,
    colorBorder: colorBorder,
  };
};

export const getArrayPlaysNotPaid = () => {
  let finalPlays = [];
  for (let index = 1; index <= 10; index++) {
    finalPlays.push({
      date_updated: "01/01/2050 00:00:00",
      game_id: "XX" + index,
      game_level: 1,
      id: "XX" + index,
      name: "Xxxxxxxxxx",
      play_score: 10 * index,
      play_time: "XX:XX",
    });
  }
  return finalPlays;
};

export const checkIsIos = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const checkPasswordValidations = (pw = null) => {
  let validation = {
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    hasMinEight: false,
  };

  const listLowercase = "qwertyuiopasdfghjklçzxcvbnm";
  const listUppercase = "QWERTYUIOPASDFGHJKLÇZXCVBNM";
  // pw = pw.replace(/[ÁÀÂÃÄ]/g, "A");
  // pw = pw.replace(/[ÉÈÊË]/g, "E");
  // pw = pw.replace(/[ÍÌÎÏ]/g, "I");
  // pw = pw.replace(/[ÓÒÔÕÖ]/g, "O");
  // pw = pw.replace(/[ÚÙÛÜ]/g, "U");
  // pw = pw.replace(/[Ç]/g, "C");
  // pw = pw.replace(/[áàâãä]/g, "a");
  // pw = pw.replace(/[éèêë]/g, "e");
  // pw = pw.replace(/[íìîï]/g, "i");
  // pw = pw.replace(/[óòôõö]/g, "o");
  // pw = pw.replace(/[úùûü]/g, "u");
  // pw = pw.replace(/[ç]/g, "c");

  if (pw) {
    validation.hasNumber = pw.replace(/\D/g, "").length > 0;
    validation.hasMinEight = pw.length >= 8;

    [...pw].forEach((char) => {
      if (!validation.hasLowercase)
        validation.hasLowercase = listLowercase.includes(char);
      if (!validation.hasUppercase)
        validation.hasUppercase = listUppercase.includes(char);
    });
  }

  return validation;
};

export const getWebGLCapabilities = (versions = ["webgl1", "webgl2"]) => {
  const canvas = document.createElement("canvas");

  let gl1 = null;
  let gl2 = null;
  
  if (versions.includes("webgl2")) {
    gl2 = canvas.getContext("webgl2");
  }

  if (versions.includes("webgl1")) {
    gl1 =
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");
  }
  return {
    webgl1: !!gl1,
    webgl2: !!gl2,
    suportAnyWebGL: !!gl1 || !!gl2,
  };
};

export const checkValidationsBt = (
  email = null,
  pw = null,
  confirmPw = null,
  userExist = null
) => {
  let validation = {
    isEmail: false,
    allRequirementsOk: false,
    isSamePassword: false,
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    hasMinEight: false,
  };
  // const originalPw = pw;

  const listLowercase = "qwertyuiopasdfghjklçzxcvbnm";
  const listUppercase = "QWERTYUIOPASDFGHJKLÇZXCVBNM";
  // pw = pw.replace(/[ÁÀÂÃÄ]/g, "A");
  // pw = pw.replace(/[ÉÈÊË]/g, "E");
  // pw = pw.replace(/[ÍÌÎÏ]/g, "I");
  // pw = pw.replace(/[ÓÒÔÕÖ]/g, "O");
  // pw = pw.replace(/[ÚÙÛÜ]/g, "U");
  // pw = pw.replace(/[Ç]/g, "C");
  // pw = pw.replace(/[áàâãä]/g, "a");
  // pw = pw.replace(/[éèêë]/g, "e");
  // pw = pw.replace(/[íìîï]/g, "i");
  // pw = pw.replace(/[óòôõö]/g, "o");
  // pw = pw.replace(/[úùûü]/g, "u");
  // pw = pw.replace(/[ç]/g, "c");

  if (email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    validation.isEmail = emailRegex.test(email) && !userExist;
  }
  if (pw) {
    validation.hasNumber = pw.replace(/\D/g, "").length > 0;
    validation.hasMinEight = pw.length >= 8;

    [...pw].forEach((char) => {
      if (!validation.hasLowercase)
        validation.hasLowercase = listLowercase.includes(char);
      if (!validation.hasUppercase)
        validation.hasUppercase = listUppercase.includes(char);
    });
  }

  validation.isSamePassword = pw === confirmPw && pw.length !== 0;

  validation.allRequirementsOk =
    validation.hasNumber &&
    validation.hasMinEight &&
    validation.hasLowercase &&
    validation.hasUppercase;

  return validation;
};

export const checkValidationsPhone = (ph = null, confirmPh = null) => {
  let validation = {
    isSamePhone: false,
  };

  validation.isSamePhone = ph === confirmPh && ph.length !== 0;

  return validation;
};

export const checkInformationValidations = (
  nick = null,
  phone = null,
  birthday = null,
  occupation = null
) => {
  let validation = {
    hasNick: false,
    hasPhone: false,
    hasBirthday: false,
    hasOccupation: false,
  };
  if (nick) {
    validation.hasNick = nick.length >= 1;
  }
  if (phone) {
    validation.hasPhone = phone.length >= 9;
  }
  if (birthday) {
    validation.hasBirthday = birthday.length >= 1;
  }
  if (occupation) {
    validation.hasOccupation = occupation.length >= 1;
  }
  return validation;
};

export const checkValidationCode = (code = null, validCode = null) => {
  let validation = {
    hasCode: false,
  };

  if (code?.length === 0) {
    validation.hasCode = code.length === 0;
  }
  if (validCode) {
    validation.hasCode = true;
  }
  return validation;
};

export const getLabelLeverOrBonusLevel = (play = "", level) => {
  let label = "global.level_" + level;
  if (play && play.bonus_level && play.bonus_level !== "") {
    label = play.bonus_level;
  }
  return label;
};

// export const checkIsShowingModalLimit = (session) => {
//   console.log("session checkIsShowingModalLimit: ",session)
//   const isUserFree = ["individual_free","parent_free"].indexOf(session.my_user.type_user)>-1
//     // session &&
//     // session.permissions &&
//     // session.permissions.game &&
//     // session.permissions.game[0] === "free" &&
//     // session.plans &&
//     // session.plans.permissions &&
//     // session.plans.permissions.game &&
//     // session.plans.permissions.game.length <= 1 &&
//     // !session.is_parent_paid;
//   console.log("isUserFree Func: ",isUserFree)
//   return isUserFree;
// };
export const checkIsShowingModalLimit = (session) => {
  // const isUserFree =
  //   session?.plans?.permissions?.game[0] === "free" &&
  //   session?.plans?.permissions?.game.length <= 1 &&
  //   !session?.is_parent_paid;
  const isUserFree =
    session?.my_user?.typeUser &&
    session?.my_user?.typeUser.includes("free") &&
    !session?.is_parent_paid;
  return isUserFree;
};

export const checkIsFree = (session) => {
  // const isUserFree =
  //   session?.plans?.permissions?.game[0] === "free" &&
  //   session?.plans?.permissions?.game.length <= 1 &&
  //   !session?.is_parent_paid;
  const isUserFree =
    session?.my_user?.typeUser &&
    session?.my_user?.typeUser.includes("free") &&
    !session?.is_parent_paid;
  return isUserFree;
};
  export const isValidCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf[i]) * (10 - i);
    }
    let firstDigit = (sum * 10) % 11;
    if (firstDigit === 10 || firstDigit === 11) firstDigit = 0;
    if (firstDigit !== parseInt(cpf[9])) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf[i]) * (11 - i);
    }
    let secondDigit = (sum * 10) % 11;
    if (secondDigit === 10 || secondDigit === 11) secondDigit = 0;
    return secondDigit === parseInt(cpf[10]);
  };

  export const isValidCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, "");
    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    let digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers[length - i] * pos--;
      if (pos < 2) pos = 9;
    }
    let firstDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (firstDigit !== parseInt(digits[0])) return false;

    length += 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers[length - i] * pos--;
      if (pos < 2) pos = 9;
    }
    let secondDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return secondDigit === parseInt(digits[1]);
  };
